import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreReducers, CoreState, getLocalStorage, pictureService } from "@reco-m/core";
import { app, distinct } from "@reco-w/core-ui";

import { IParkBindTableNameEnum } from "@reco-w/common-common";
import { Namespaces as commonNamespaces } from "@reco-w/common-models";
import { stateFlowService } from "@reco-w/approval-service";
import { serviceProductService, marketService } from "@reco-w/market-service";

import { Namespaces, InstitutionStatusEnum, InstitutionCustomTypeEnum, MyMarketTabEnum } from "./common";

export namespace myMarketModel {
    export const namespace = Namespaces.myMarket;

    export const state: any = freeze(
        {
            ...CoreState,
            isAgree: true,
            index: "1",
        },
        !0
    );

    export type StateType = typeof state;
    export const reducers: ReducersMapObject = {
        ...CoreReducers,
        *init() {
            return state;
        },
    };
    export const effects: EffectsMapObject = {
        ...CoreEffects,

        *initPage({ message, callback }, { call, put }) {
            try {
                // yield put({ type: "init" });
                yield put({ type: "getMarketInInit", message, callback });
                yield put({ type: "getAcceptanceMode", message });
            } catch (e) {
                yield call(message!.error, "initPage：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },

        /**
         * 获取我的机构
         * @param { message, callback }
         * @param { call, put }
         */
        *getMarketInInit({ message, callback }, { call, put }) {
            try {
                yield put({ type: "showLoading" });

                const marketDetail = yield call(marketService.getMyInstitution);

                const { contactPersonalCommonVM: personCommon = {} } = marketDetail || {};

                yield put({
                    type: "getPicturesWithName",
                    data: { bindTableName: IParkBindTableNameEnum.institution, bindTableId: personCommon.bindTableId, customType: InstitutionCustomTypeEnum.qualification },
                    map: "qualificationPics",
                });

                yield put({
                    type: "getPicturesWithName",
                    data: { bindTableName: IParkBindTableNameEnum.institution, bindTableId: personCommon.bindTableId, customType: InstitutionCustomTypeEnum.case },
                    map: "institutionLicensePics",
                });

                yield put({ type: "input", data: { marketDetail, institutionId: personCommon.bindTableId } });

                if (callback) {
                    yield call(callback, marketDetail);
                }
            } catch (e) {
                yield call(message!.error, "getMarketInInit：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
        /**
         * 判断是机构还是产品
         */
        *judgeIsMarket({ message, params, status, institutionId }, { put, call }) {
            try {
                yield put({ type: "showLoading" });
                if (params["tt"] === MyMarketTabEnum.marketApply) {
                    const data = {
                        pageIndex: params["pi"] || 1,
                        pageSize: params["ps"] || 10,
                        status,
                    };
                    yield put({
                        type: "getMyInstitutionAndProductWorkOrder",
                        institutionId: institutionId,
                        params: data,
                    });
                } else if (params["tt"] === MyMarketTabEnum.product) {
                    const data = {
                        pageIndex: params["pi"] || 1,
                        pageSize: params["ps"] || 8,
                        orderBy: "",
                        parkId: getLocalStorage("parkId"),
                        institutionId: institutionId,
                    };

                    yield put({ type: "getProductList", data });
                }
            } catch (e) {
                yield call(message!.error, "judgeIsMarket：" + e.errmsg);
            }
        },
        /**
         * 获取服务工单
         * @param { message }
         * @param { call, put, select }
         */
        *getMyInstitutionAndProductWorkOrder({ message, params }, { call, put, select }) {
            try {
                yield yield put({ type: `${commonNamespaces.memberCommon}/getCurrentUser` });
                let memberCommonState: any = yield select((state) => state[commonNamespaces.memberCommon]),
                    user = memberCommonState?.user?.currentUser;

                const result = yield call(marketService.getMyInstitutionAndProductWorkOrder, {
                    parkId: getLocalStorage("parkId"),
                    principalUserId: user?.id,
                    codes: "fuwsl,fuwcp",
                    isStateOrder: true,
                    ...params,
                });

                let func = (all, allRouteList, route, d) => {
                    if (all && all.length > 1) {
                        allRouteList[d] = all;
                        route.All = true;
                    }
                };

                if (result.items && result.items.length > 0) {
                    for (let i = 0; i < result.items.length; i++) {
                        let item = result.items[i];
                        let routes = item.state && item.state.flow && item.state.flow.process && item.state.flow.process.routes;
                        let routeList = routes && routes.filter((r) => r.fromNodeId === item.state.project.currentNodeId);
                        let allRouteList = {};
                        if (routeList && routeList.some((x) => x.postConditions && x.postConditions.length > 0)) {
                            let routeByApi = yield call(stateFlowService.getStateRoutes, {
                                flowProjectId: item.state.project.id,
                                componentData: item.state.projectContent.componentData,
                            });
                            let routeNames = distinct(
                                routeByApi.map((d: any) => d.routeName),
                                []
                            );

                            let projectRouteList: any[] = [];

                            for (let j = 0; j < routeNames.length; j++) {
                                let d = routeNames[j];
                                let route = routeList.find((r: any) => r.routeName === d);
                                let all = routeList.filter((r: any) => r.routeName === d);
                                func(all, allRouteList, route, d);
                                // if (all && all.length > 1) {
                                //     allRouteList[d] = all
                                //     route.All = true;
                                // }
                                projectRouteList.push(route);
                            }

                            routeList = projectRouteList;
                        }
                        item.RouteList = routeList;
                        item.AllRoute = allRouteList;
                    }
                }

                yield put({ type: "input", data: { orders: result?.items, orderTotal: result?.totalItems } });
            } catch (e) {
                yield call(message!.error, "getMyInstitutionAndProductWorkOrder：" + e.errmsg);
            }
        },

        /**
         * 获取受理模式
         * @param { message }
         * @param { call, put }
         */
        *getAcceptanceMode({ message }, { call, put }) {
            try {
                const institutionMode = yield call(marketService.getAcceptanceMode);

                yield put({ type: "input", data: { institutionMode } });
            } catch (e) {
                yield call(message!.error, "getAcceptanceMode：" + e.errmsg);
            }
        },

        *modifyInstitution({ message, callback }, { call, put, select }) {
            try {
                yield put({ type: "input", data: { isSubmit: true } });

                const state: any = yield select((state) => state[Namespaces.myMarket]),
                    institution = state.institution;

                if (institution) {
                    const params = {
                        organization: {
                            contactPerson: state!.contactPerson,
                            mobile: state!.mobile,
                            tel: state!.tel,
                            email: state!.email,
                            website: state!.website,
                            id: institution && institution.id,
                        },
                        id: institution && institution.id,
                    };

                    yield call(marketService.put, institution.id, params);

                    yield put({ type: `${commonNamespaces.workorderCommon}/cleanInstitution` });

                    if (callback) yield call(callback);
                }
            } catch (e) {
                yield call(message!.error, e.errmsg);
            }
        },

        /**
         * 获取图片数据
         * @param { message, data, map }
         * @param { call, put }
         */
        *getPicturesWithName({ message, data, map }, { call, put }) {
            try {
                const pictureData = yield call(pictureService.getPictureList, data);
                yield put({ type: "input", data: { [map]: pictureData } });
            } catch (e) {
                yield call(message!.error, e.errmsg);
            }
        },

        /**
         * 获取产品列表
         * @param { message, data }
         * @param { call, put }
         */
        *getProductList({ message, data }, { call, put }) {
            try {
                yield put({ type: "showLoading" });
                // 全部
                const result = yield call(serviceProductService.getPaged, {
                    ...data,
                });
                // 上架
                const validResult = yield call(serviceProductService.getPaged, {
                    isOnService: true,
                    ...data,
                    status: InstitutionStatusEnum.pass,
                });
                // 下架
                const unvalidResult = yield call(serviceProductService.getPaged, {
                    isOnService: false,
                    ...data,
                    status: InstitutionStatusEnum.pass,
                });
                // 待审核
                const shResult = yield call(serviceProductService.getPaged, {
                    ...data,
                    status: InstitutionStatusEnum.waitAudit,
                });
                // 退回
                const thResult = yield call(serviceProductService.getPaged, {
                    ...data,
                    status: InstitutionStatusEnum.notPass,
                });
                // 取消
                const qxResult = yield call(serviceProductService.getPaged, {
                    ...data,
                    status: InstitutionStatusEnum.cancel,
                });
                yield put({
                    type: "input",
                    data: {
                        allProducts: result.items,
                        allTotal: result.totalItems,
                        validProducts: validResult.items, // 上架
                        validTotal: validResult.totalItems,
                        unvalidProducts: unvalidResult.items, // 下架
                        unvalidTotal: unvalidResult.totalItems,
                        shProducts: shResult.items, // 待审核
                        shTotal: shResult.totalItems,
                        thProducts: thResult.items, // 退回
                        thTotal: thResult.totalItems,
                        qxProducts: qxResult.items, // 取消
                        qxTotal: qxResult.totalItems,
                    },
                });
            } catch (e) {
                yield call(message!.error, "getInstitution：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },

        *serviceProductValid({ message, id, isOnService, callback }, { call, put }) {
            try {
                yield put({ type: "showLoading" });

                // const result = yield call(serviceProductService.serviceProductValid, data);
                const result = yield call(serviceProductService.onService, id, isOnService);

                callback(result);
            } catch (e) {
                yield call(message!.error, "getInstitution：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
        *cancelAudit({ message, id, callback }, { call, put }) {
            try {
                yield put({ type: "showLoading" });
                const result = yield call(serviceProductService.cancelProductAudit, id);
                callback(result);
            } catch (e) {
                yield call(message!.error, "getInstitution：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
    };
}

app.model(myMarketModel);
